import React from 'react'
import HeadingForm from '../elements/HeadingForm'
import OrderHisItem from './OrderHisItem'
import OrderFoodItem from './OrderFoodItem'
import DynamicColor from '../common/dynamic-color'
import FormatCurrency from '../elements/FormatCurrency'

import { ensureArray } from '../../utils/helper'
import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'

const OrderDetails = ({ orderDetails }) => {
    const { t } = useTranslation()

    const { foodData, customer, totalMoney, ...rest } = orderDetails

    return (
        <div className="container-fluid container-xl order-details flex-1 py-6">
            <HeadingForm>{t('title.orderDetails')}</HeadingForm>

            <div className="mt-6">
                <OrderHisItem details={{ ...customer, ...rest, totalMoney }} />
            </div>

            {/* <div className="mt-6">
                <OrderFoodItem head editAble />
                <OrderFoodItem className="mt-2" editAble />
            </div> */}

            <HeadingForm className="mt-4 sub-title">
                {t('Thông tin mặt hàng')}
            </HeadingForm>

            <DynamicColor
                style={{
                    // backgroundColor: COLOR_NAME.BOX_BG,
                    borderColor: COLOR_NAME.BODY_LINE,
                }}
                className="mt-4 order-details__list"
            >
                {/* <OrderFoodItem head /> */}

                {ensureArray(foodData).map(food => (
                    <OrderFoodItem key={food.plu} food={food} />
                ))}
            </DynamicColor>

            <div className="row">
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="col-12 col-md-6 offset-md-6 col-lg-4 offset-lg-8 flex-between heading-5 py-8"
                >
                    <div>{t('orderDetails.totalAmount')}</div>
                    <div>
                        <FormatCurrency amount={totalMoney} />
                    </div>
                </DynamicColor>
            </div>
        </div>
    )
}

export default OrderDetails
